export default "__VITE_ASSET__e09a8843__"